module.exports = __webpack_public_path__ + "static/img/download_b.4711e4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download_b.jpg
// module id = 2qGQ
// module chunks = 1